import Stack from "@mui/material/Stack";
import { type TextFieldProps as TextFieldPropsMui } from "@mui/material/TextField";
import { isEmpty } from "lodash";
import { FC } from "react";
import { useController, useFormContext } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";
import * as Styled from "./TextInput.styled";

export type TextFieldProps = Omit<TextFieldPropsMui, "name"> & {
    name: string;
    disabled?: boolean;
    label?: React.ReactNode;
    isRequired?: boolean;
    sublabel?: string;
    afterChange?: (value: string) => void;
    LabelComponent?: React.ElementType;
    WrapperComponent?: React.ElementType;
};

export const TextInput: FC<TextFieldProps> = ({
    name,
    disabled = false,
    label,
    sublabel,
    isRequired = false,
    LabelComponent = "label",
    WrapperComponent = Stack,
    afterChange,
    ...rest
}) => {
    const { register } = useFormContext();
    const { fieldState } = useController({ name });
    const { error } = fieldState;
    const inputProps = register(name);

    return (
        <WrapperComponent>
            {!isEmpty(label) && (
                <LabelComponent htmlFor={`${name}-name`}>
                    <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>
                </LabelComponent>
            )}
            {!isEmpty(sublabel) && <StyledCommon.InputSubLabel>{sublabel}</StyledCommon.InputSubLabel>}
            <Styled.TextField
                error={!!error}
                type="text"
                required={isRequired}
                id={`${name}-name`}
                disabled={disabled}
                variant="outlined"
                {...rest}
                {...inputProps}
                onChange={(e) => {
                    inputProps.onChange?.(e);
                    afterChange?.(e.target.value);
                }}
            />
            <FormError error={error} fieldName={name} />
        </WrapperComponent>
    );
};
